import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=2492df22&scoped=true&"
import script from "./UserActivity.vue?vue&type=script&lang=js&"
export * from "./UserActivity.vue?vue&type=script&lang=js&"
import style0 from "./UserActivity.vue?vue&type=style&index=0&id=2492df22&prod&scoped=true&lang=css&"
import style1 from "./UserActivity.vue?vue&type=style&index=1&id=2492df22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492df22",
  null
  
)

export default component.exports